module.exports = __webpack_public_path__ + "static/img/发票管理1.b47907f8.png";